import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/tr';
export const locale = {
  lang: 'tr',
  data: {
    'GENERICSURVEY': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
      },
      'TITULO': 'Genel anket raporu',
      'SUBTITULO': 'Girerek genel anket raporuna bakın',
      'CAMPOS': {
        'Token': 'Jeton:',
      },
      'RESULTADOS': {
        'CARGANDO': 'Arama sonuçları yükleniyor',
        'TITULO': 'Sonuçlar',
        'ENCONTRADAS': 'Bulunan toplam kullanıcı sayısı',
        'DESCARGAR': 'Bilgileri Excel biçiminde indirme',
        'SINRESULTADOS': 'Belirtilen belirteç için kullanıcı bulunamadı'
      }
    }
  }
};
